import { Alert, Dialog, DialogContent, DialogTitle, Typography, } from "@mui/material";
import PaperDraggable from "../../../PaperDraggable";
import { formatarMonetárioParaNúmero, formatarValorMonetario } from "../../../../helpers/masks";
import { FormProvider, useForm } from "react-hook-form";
import { useQuery } from "react-query";
import axiosClient from "../../../../lib/axios";
import { IVerificarTefConfig } from "../../../../types/api/financeiro/verificar-tef-config";
import { AxiosResponse } from "axios";
import DialogCartaoSkeleton from "./DialogCartaoSkeleton";
import ManualForm from "./ManualForm";
import TefForm from "./TefForm";
import { useState } from "react";

export default function DialogCartao({
    open,
    valor,
    defaultValues,
    isEdit,
    onSubmit,
    onClose,
    pagamentoId,
    onReceberPagamento
}: DialogCartaoProps) {

    const [tefConfig, setTefConfig] = useState<IVerificarTefConfig["tef_config"] | null>(null);

    const { data: verificarTef, isLoading: isLoadingTef } = useQuery<AxiosResponse<IVerificarTefConfig>>({
        queryKey: ["verificar-tef-config", pagamentoId],
        queryFn: () => axiosClient.get(`/financeiro/verificar-tef-config`, {
            params: {
                pedido_pagamento_id: pagamentoId
            }
        }),
        onSuccess: (data) => {
            setTefConfig(data.data.tef_config);
        },
        enabled: open,
        cacheTime: 0,
        staleTime: 0
    })


    const methods = useForm<TPagamentoCartao>({
        defaultValues: {
            valor: defaultValues?.valor ? formatarValorMonetario(defaultValues?.valor) : formatarValorMonetario(valor),
            nsu: defaultValues?.nsu || "",
            autorizacao: defaultValues?.autorizacao || ""
        }
    })

    //Functions
    const handleClickSubmit = (data: TPagamentoCartao) => {
        const params: TPagamentoCartaoParams = {
            valor: formatarMonetárioParaNúmero(data.valor),
            nsu: data.nsu,
            autorizacao: data.autorizacao
        }
        onSubmit(params);
    }

    if (isLoadingTef) {
        return <DialogCartaoSkeleton open={open} />;
    }

    return (
        <FormProvider {...methods}>
            <Dialog
                open={open}
                PaperComponent={PaperDraggable}
                aria-labelledby="draggable-dialog-title"
                fullWidth
                maxWidth={"xs"}
            >
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Cartão</DialogTitle>

                <DialogContent>
                    {
                        tefConfig ? (
                            <TefForm
                                tefConfig={tefConfig}
                                pagamentoId={pagamentoId}
                                valor={valor}
                                onClose={onClose}
                                onSubmit={handleClickSubmit}
                                onReceberPagamento={onReceberPagamento}
                                isEdit={isEdit}
                                setManual={() => {
                                    setTefConfig(null);
                                }}
                            />
                        ) : (
                            <>
                                <Alert severity="warning" icon={false}>
                                    <Typography variant="subtitle2">
                                        Não foi possível encontrar a configuração do TEF para esta forma de recebimento.
                                    </Typography>
                                </Alert>
                                <ManualForm 
                                    onClose={onClose}
                                    onSubmit={handleClickSubmit}
                                    isEdit={isEdit}
                                />
                            </>
                        )
                    }
                </DialogContent>
            </Dialog>
        </FormProvider>
    )
}

interface DialogCartaoProps {
    open: boolean;
    onClose: () => void;
    onSubmit: (data: TPagamentoCartaoParams) => void;
    valor: number;
    defaultValues?: TPagamentoCartaoParams;
    isEdit: boolean;
    pagamentoId: number;
    onReceberPagamento?: (id: number, data: TPagamentoCartaoParams | null) => void;
}

export type TPagamentoCartao = {
    valor: string;
    nsu: string;
    autorizacao: string;
}

export type TPagamentoCartaoParams = {
    valor: number;
    nsu: string;
    autorizacao: string;
}